import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncidentControlRoutingModule } from './incident-control-routing.module';
import { IncidentControlComponent } from './incident-control.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { IncidentControlService } from './incident-control.service';

import { MatIconModule } from "@angular/material/icon";

// Ngx-boostrap
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  imports: [
    CommonModule,
    IncidentControlRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatIconModule,
    ModalModule.forRoot()
  ],
  declarations: [
    IncidentControlComponent
  ],
  providers:[NgxSpinnerService,IncidentControlService]
})
export class IncidentControlModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/incident-control/incident-control.module.ts